const formAPItoken = "fjF*3ifj3nap1!04f82dsj!!#%MqpzZQM";

export default {
  formAPItoken: formAPItoken,
};
